

















































import Vue from 'vue'
import { Additive, Allergen, Menu } from '@/types/generated/graphql'
import XCard from '@/components/atoms/Card/XCard.vue'
import DishContents from '@/components/molecules/FfGoods/Detail/DishContents.vue'
import Ingredients from '@/components/molecules/FfGoods/Detail/Ingredients.vue'

type Props = {
  menu: Menu
}
type Computed = {
  allergens: Array<string>
  additives: Array<string>
}
export default Vue.extend<{}, {}, Computed, Props>({
  name: 'MenuContents',
  components: { XCard, DishContents, Ingredients },
  props: {
    menu: {
      type: Object,
      required: true,
    },
  },
  computed: {
    allergens() {
      const allergens = this.menu.allergens as Array<Allergen>
      return allergens.map((a) => a.name)
    },
    additives() {
      const additives = this.menu.additives as Array<Additive>
      return additives.map((a) => a.name)
    },
  },
})
